import "./TabHeader.css";
import { useEffect, useState } from "react";
import { TabProps } from "../types/tabTypes";

function TabHeader({ data, updateContent }: TabProps) {
  const [active, setActive] = useState(data[0].id);

  useEffect(() => {
    updateContent && updateContent(data.find(({ id }) => id === active));
  }, [active, data, updateContent]);

  return (
    <ul className="tabHeader nav nav-tabs row m-0">
      {data.map((tab) => {
        return (
          <li className="nav-item col-3 p-0" key={tab.id}>
            <button
              className={`btn form-control nav-link ${
                active === tab.id ? "active" : ""
              }`}
              aria-current="page"
              onClick={() => setActive(tab.id)}
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              data-bs-title={tab.title}
            >
              {tab.title}
            </button>
          </li>
        );
      })}
    </ul>
  );
}

export default TabHeader;
